export default __webpack_public_path__ + "static/media/music.9a9c76b0.mp3";